/**
 * Furyu Bannerを表すview model.
 */
export default class FuryuBannerViewModel {
    constructor(data) {
        this.bannerHtml = data.bannerHtml
    }
}